import React from 'react';
import {Navigation} from 'swiper/modules';
import {Swiper, SwiperSlide} from 'swiper/react';

// Styles must use direct files imports
import 'swiper/css';
import 'swiper/css/navigation';
import {StyledGoodsSlider} from "./style";
import {GLOBAL_STYLE_CONFIG} from "../../../../app/styles/GlobalStyles";

interface IProps {
    images: string[];
}

const GoodsSlider: React.FC<IProps> = ({images}) => {
    return (
        <StyledGoodsSlider className={GLOBAL_STYLE_CONFIG.splitByPrefix('card-media-slider')}>
            <Swiper
                modules={[Navigation]}
                pagination={{clickable: true}}
                spaceBetween={10}
                slidesPerView={1}
                navigation
                style={{
                    maxHeight: 'inherit',
                }}
                // autoHeight={true}
            >
                {images.map((img, index) => (
                    <SwiperSlide key={index} style={{
                        height: 'inherit',
                        // display: 'flex',
                        // justifyContent: 'center',
                        // alignItems: 'center'
                    }}>
                        <img
                            loading={"lazy"}
                            src={img}  // Можно указать src как fallback (если lazy не сработает)
                            data-src={img}  // URL для lazy loading
                            className="swiper-lazy"  // Класс для ленивой загрузки
                            alt={`Image ${index}`}
                        />
                        <div className="swiper-lazy-preloader"/>
                    </SwiperSlide>
                ))}
            </Swiper>
        </StyledGoodsSlider>
    );
};

export default GoodsSlider;